import { useEffect } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { DateInput, toDateOnly, MoneyInput, TextareaInput, TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"
import { useApi } from "../../hooks/useApi"
import { Currency } from "../../hooks/helpers"

function PrixChantierFields({ item, set }) {
    const t = useTranslations()
    const api = useApi()

    useEffect(() => {
        if (!item?.id && item?.chantierId) {
            api.get(`/chantiers/${encodeURIComponent(item?.chantierId)}`).then(chantier => {
                set('date')(toDateOnly(new Date()))
                set('prixAchat')(chantier.prixAchat)
                set('prixVente')(chantier.prixVente)
            })
        }
    }, [item?.id, item?.chantierId])

    return <>
        <Row>
            <DateInput label={t("Date")} value={item.date} onChange={set('date')} required />
            <MoneyInput className="grow" label={t("Prix d'achat")} value={item.prixAchat} onChange={set('prixAchat')} required />
            <MoneyInput className="grow" label={t("Prix de vente")} value={item.prixVente} onChange={set('prixVente')} required />
        </Row>
        <Row>
            <TextInput className="grow" label={t("Note sur première facture FR")} value={item.noteFactureFr} onChange={set('noteFactureFr')} />
            <TextInput className="grow" label={t("Note sur première facture NL")} value={item.noteFactureNl} onChange={set('noteFactureNl')} />
            <TextInput className="grow" label={t("Note sur première facture EN")} value={item.noteFactureEn} onChange={set('noteFactureEn')} />
        </Row>
        <TextareaInput className="[&_textarea]:text-red-600" label={t("Mémo interne")} value={item.memoInterne} onChange={set('memoInterne')} />
    </>
}

export function PrixChantiersList(props) {
    const t = useTranslations()
    return <ListPage model="prixChantiers" title={t("Historique des prix")} columns={{
        [t('Date')]: 'date',
        [t("Prix d'achat")]: { sort: 'prixAchat', value: item => <Currency value={item.prixAchat} /> },
        [t('Prix de vente')]: { sort: 'prixVente', value: item => <Currency value={item.prixVente} /> },
        [t('Mémo interne')]: 'memoInterne',
    }} sort={{
        [t('Date')]: 'desc',
    }} {...props} />
}

export function PrixChantierDetail(props) {
    const t = useTranslations()
    return <DetailPage model="prixChantiers" title={t("Historique des prix")} Fields={PrixChantierFields} {...props} />
}
